import React, {useState} from "react";
import { Helmet } from "react-helmet";
import {Accordion, Card, ListGroup, Badge} from "react-bootstrap";

import Header from "./header";
import Footer from "./footer";
import Layout from "./layout";
import ContractForm from './contact-form';
import CTA from './cta';

import benefitsImage from '../images/benefits.png';
import arrowDownIcon from '../images/icons/arrow-down.svg';
import arrowUpIcon from '../images/icons/arrow-up.svg';

function FAQ({index, title, description, selected}) {
    const [isSelected, setIsSelected] = useState(false);

    return (
        <Card>
            <Accordion.Toggle as={Card.Header} eventKey={index} onClick={(e) => setIsSelected(!isSelected)}>
                {title}
                {!isSelected && (
                    <img src={arrowDownIcon} className="float-right" alt="arrow" />
                )}
                {isSelected && (
                    <img src={arrowUpIcon} className="float-right" alt="arrow" />
                )}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={index}>
                <Card.Body>
                    <p className='mb-0'>
                        {description}
                    </p>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
}

// markup
const TopicPage = ({post}) => {
  const meta = post.metaDescription || 'MatteCurve is one of the leading javascript development company in India providing Custom Software, Web and Mobile Application Development services like node.js, meteor.js, react.js and many more services.';
  const faqs = [
    {
        title: 'How do you assure that my project or idea is secure with MatteCurve Technologies Pvt. Ltd.?',
        description: 'Before we start detailed discussion we would sign non-disclosure agreement (NDA). Every resource who works with us signs Non-Disclosure, Non-solicitation, and Non-Compete Agreement on the first day of joining our company.',
    },
    {
        title: 'How do you communicate and share progress?',
        description: 'We are AGILE. We communicate our progress every day through slack or email. We use JIRA for tracking of tasks and every task is updated properly with proper description and stages like Open, Inprogress, Completed, Tested and Closed.',
    },
    {
        title: 'What should be the minimum size of the team, I have to hire?',
        description: 'You can hire only 1 developer or a complete team, we have no limit.',
    },
    {
        title: 'How do you assure that the quality work will be done with proper documentation?',
        description: 'We are very thoughtful about the code we write. All of our developers are trained to write very good code. We have code review policy. If you are hiring a team, they would do code review of peer developers and if you are hiring a 1 developer, some one from engineering would make sure that the developer is writing good with proper documentation;',
    },
    {
        title: 'Do you have enough resources to scale my team?',
        description: 'Yes. We have a trained in house team who are experts in javascript technologies. Also we have a community of 1000+ developers, so we can find a resource immediately when we need.',
    },
    {
        title: 'What are the payment terms?',
        description: 'Monthly Payments. We usually take first month payment in advance.',
    }
  ];

  return (
    <Layout pageClass="topic-page">
        <Helmet>
            <title>{post.title} - MatteCurve</title>
            <meta name="description" content={meta} />
            <meta name="keywords" content="Web Development, Mobile App Development, React, Node.js, Angular.js, Remote Developers" />
        </Helmet>
        <Header></Header>
        <main>
            <div className="row topic-main-section">
                <div className="col">
                    <div className="message-column">
                        <h1 className="animate__animated animate__fadeInUp">{post.h1}</h1>
                        <h2 className="animate__animated animate__fadeInUp">
                            {post.h1Subtext1}
                        </h2>
                        <p className="animate__animated animate__fadeInUp">
                            {post.h1Subtext2}
                        </p>
                    </div>
                </div>
                <div className="col">
                    <div className="contact-form-column">
                        <ContractForm />
                    </div>
                </div>
            </div>
            <div className="row mt-5 topic-about-section">
                <div className="col col-12 col-md-6 mt-5">
                    <div className="col-content">
                        <div className="section-heading">{post.aboutSection.title}</div>
                        <h3>
                            {post.aboutSection.subTitle}
                        </h3>
                        <div>
                            <p>
                                {post.aboutSection.paragraph1}
                            </p>
                            <p>
                                {post.aboutSection.paragraph2}
                            </p>
                            <p>
                                {post.aboutSection.paragraph3}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col col-12 col-md-6 mt-5">
                    <div className="col-content">
                        <div className="section-heading">
                            Key Points
                        </div>
                        <ListGroup>
                            {post.aboutSection.keyPoints.map((keyPoint, keyPointIndex) => (
                                <ListGroup.Item key={keyPointIndex} style={{border: 0, padding: "10px 0rem"}}><Badge variant="dark">{keyPointIndex+1}</Badge> {keyPoint}</ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                </div>
            </div>
            <div className="row topic-stats-section">
                <div className="col">
                    <p>
                    {post.statsSection.paragraph}
                    </p>
                </div>
            </div>
            <div className="row mt-5 topic-benefits-section">
                <div className="col col-12 col-md-6 mt-0 mt-md-5">
                    <div className="col-content">
                        <div className="section-heading">
                        {post.benefitsSection.title}
                        </div>
                        <ListGroup>
                            {post.benefitsSection.keyPoints.map((keyPoint, keyPointIndex) => (
                                <ListGroup.Item key={keyPointIndex} style={{border: 0, padding: "10px 0rem"}}><Badge variant="dark">{keyPointIndex+1}</Badge> {keyPoint}</ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                </div>
                <div className="col col-12 col-md-6 mt-0 mt-md-5">
                    <div className="col-content">
                        <img src={benefitsImage} alt={post.benefitsSection.title} />
                    </div>
                </div>
            </div>
            <div className="topic-cta-section">
                <CTA text={post.ctaTexts[1]}></CTA>
            </div>
            <div className="row mt-5 topic-why-us-section">
                <div className="col col-12 mt-0 mt-md-5">
                    <div className="col-content">
                        <div className="section-heading">
                            {post.why.title}
                        </div>
                        <h2>{post.why.paragraph}</h2>
                    </div>
                </div>
                <div className="col col-12 col-md-12 mt-0">
                    <div className="col-content">
                        <h4>We are agile</h4>
                        <p>In the first week of onboarding a project we discuss with our clients to choose the working process, does he/she has available to communicate day to day with our developers or they want to communicate on a weekly basis. It does not make much difference for our expert developers. Being agile our main focus is to build small shippable features, release early and get feedback from our potential customers.</p>
                        <h4>A+ engineers building your products</h4>
                        <p>We hire A+ engineers through our unique hiring process. Our expert developers write secure well-documented code, write test cases and communicate every detail with the clients. Our engineers go through a process of understanding the requirement and resolve their queries first and then they start writing code.</p>
                        <h4>Build product with strong architecture and well written test cases</h4>
                        <p>We love writing test cases and we have a solid scalable architecture to start any project quickly. We don’t write code for just today but the code written by us can be extended easily in the future.</p>
                        <h4>Automated deployment process</h4>
                        <p>We have an automated process where it does not require manual intervention to deploy web or mobile apps. This helps our expert developers to focus on writing code instead of being worried about deployments. It saves your money.</p>
                        <h4>We have research first approach</h4>
                        <p>After onboarding your project, the first week is for research. It may not require if the client has well-written documents but in most cases it requires. We will do domain analysis, build domain communication architecture and break down the work we need to do to complete the project.</p>
                </div>
                </div>
                {/* <div className="col col-12 col-md-6 mt-0 mt-md-5">
                    <div className="col-content">
                        <img alt={post.why.title} src="https://images.unsplash.com/photo-1492366254240-43affaefc3e3?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=902&q=80" />
                    </div>
                </div> */}
            </div>
            <div className="row mt-5 topic-faq-section">
                <div className="col mt-0 mt-md-5">
                    <div className="col-content">
                        <div className="section-heading">
                            FAQs
                        </div>
                        <h2>Do you have a Question for us?</h2>
                        <Accordion defaultActiveKey="1">
                            {faqs.map((faq, faqIndex) => (
                                <FAQ key={faqIndex} selected={faqIndex === 0} index={faqIndex + 1} title={faq.title} description={faq.description}></FAQ>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
            <div className="row mt-5 contact-us-section">
                <div className="col mt-0 mt-md-5">
                    <ContractForm></ContractForm>
                </div>
            </div>
        </main>
        <Footer></Footer>
    </Layout>
  )
}

export default TopicPage;
